// extracted by mini-css-extract-plugin
export default {"container__sidebar_slider":"SideBarSlider_container__sidebar_slider__rp+0r"};